<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-input size="small" v-model="query.phone" clearable maxlength="12" placeholder="号码" style="width: 180px;"
                  class="handle-input mr10"></el-input>
        <el-select size="small" v-model="query.logType" clearable placeholder="日志类型" style="width: 180px;"
                   class="handle-select mr10">
          <el-option :value="null" label="全部"></el-option>
          <el-option value="ORDER_CREATE" label="订单创建"></el-option>
          <el-option value="IMMEDIATE_ARRIVAL" label="立即到账"></el-option>
          <el-option value="NEXT_MONTH_ARRIVAL" label="次月到账"></el-option>
        </el-select>
        <el-select size="small" v-model="query.source" clearable placeholder="来源" style="width: 180px;"
                   class="handle-select mr10">
          <el-option :value="null" label="全部"></el-option>
          <el-option value="PUBLIC_ACCOUNT" label="公众号充值"></el-option>
          <el-option value="BATCH_TOPUP" label="后台批量"></el-option>
          <el-option value="FILE_RECHARGE" label="文件充值"></el-option>
        </el-select>
        <el-input size="small" v-model="query.operatorAccount" clearable placeholder="操作人" style="width: 150px;"
                  class="handle-input mr10"></el-input>
        <el-button size="small" type="primary" :class="[theme]" icon="el-icon-search" @click="getData">搜索</el-button>
        <el-button size="small" type="info" :class="[theme]" icon="el-icon-refresh" @click="resetQuery">重置</el-button>
      </div>

      <el-table
          :key="tableKey"
          :data="tableData"
          border
          class="table"
          ref="multipleTable"
          header-cell-class-name="table-header"
          max-height="600"
          :row-style="{ height: '20px' }"
          :cell-style="{ padding: '6px' }"
          :header-cell-style="{ 'text-align': 'center' }"
          stripe
          v-loading="loading">
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        
        <el-table-column label="日志类型" width="120" align="center">
          <template #default="scope">
            <el-tag v-if="scope.row" :type="getLogTypeTag(scope.row.logType)" size="small">
              {{ getLogTypeText(scope.row.logType) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column label="来源" width="120" align="center">
          <template #default="scope">
            <el-tag v-if="scope.row" :type="getSourceTag(scope.row.source)" size="small">
              {{ getSourceText(scope.row.source) }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="phone" label="号码" width="120" align="center"></el-table-column>

        <el-table-column prop="yearMonth" label="套餐周期" width="100" align="center"></el-table-column>

        <el-table-column prop="packagesName" label="运营商套餐" width="200" align="center" show-overflow-tooltip></el-table-column>

        <el-table-column prop="sjtxPackagesName" label="SJTX套餐" width="200" align="center" show-overflow-tooltip></el-table-column>

        <el-table-column label="操作人" width="120" align="center">
          <template #default="scope">
            {{ scope.row ? scope.row.operatorAccount : '' }}
          </template>
        </el-table-column>

        <el-table-column label="号码状态" width="100" align="center">
          <template #default="scope">
            {{ scope.row ? (scope.row.numberState || '-') : '-' }}
          </template>
        </el-table-column>

        <el-table-column label="余额" width="100" align="center">
          <template #default="scope">
            {{ scope.row && scope.row.currentBalance ? scope.row.currentBalance.toFixed(2) : '-' }}
          </template>
        </el-table-column>

        <el-table-column label="充值金额" width="100" align="center">
          <template #default="scope">
            <span v-if="scope.row" style="color: #E6A23C; font-weight: bold;">
              {{ scope.row.rechargeAmount ? scope.row.rechargeAmount.toFixed(2) : '-' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="立即到账" width="100" align="center">
          <template #default="scope">
            <span v-if="scope.row" style="color: #67C23A;">
              {{ scope.row.immediateArrivalAmount ? scope.row.immediateArrivalAmount.toFixed(2) : '-' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="次月到账" width="100" align="center">
          <template #default="scope">
            <span v-if="scope.row" style="color: #409EFF;">
              {{ scope.row.nextMonthArrivalAmount ? scope.row.nextMonthArrivalAmount.toFixed(2) : '-' }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="截留金额" width="100" align="center">
          <template #default="scope">
            {{ scope.row && scope.row.needIntercept ? scope.row.needIntercept.toFixed(2) : '-' }}
          </template>
        </el-table-column>

        <el-table-column label="处理类型" width="130" align="center">
          <template #default="scope">
            {{ scope.row ? (scope.row.processType || '-') : '-' }}
          </template>
        </el-table-column>

        <el-table-column label="失败原因" width="200" align="center">
          <template #default="scope">
            <el-tooltip v-if="scope.row && scope.row.failReason" :content="scope.row.failReason" placement="top">
              <span style="color: #F56C6C;">{{ scope.row.failReason }}</span>
            </el-tooltip>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column prop="remark" label="备注" width="200" show-overflow-tooltip></el-table-column>

        <el-table-column label="创建时间" width="160" align="center">
          <template #default="scope">
            {{ scope.row ? formatTime(scope.row.createdAt) : '' }}
          </template>
        </el-table-column>

        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template #default="scope">
            <el-button v-if="scope.row" size="mini" type="primary" @click="showDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
            background
            layout="total, prev, pager, next, sizes"
            :current-page="query.pageIndex"
            :page-size="query.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pageTotal"
            @current-change="handlePageChange"
            @size-change="handleSizeChange">
        </el-pagination>
      </div>
    </div>

    <!-- 详情对话框 -->
    <el-dialog title="日志详情" v-model="detailVisible" width="800px">
      <el-table :data="detailList" border stripe style="width: 100%;" v-if="detailList.length > 0">
        <el-table-column prop="label" label="字段名" width="150" fixed></el-table-column>
        <el-table-column prop="value" label="值">
          <template #default="scope">
            <div v-if="scope.row.isTag">
              <el-tag :type="scope.row.tagType" size="small">
                {{ scope.row.value }}
              </el-tag>
            </div>
            <div v-else-if="scope.row.isSuccess" :style="{ color: scope.row.color }">
              {{ scope.row.value }}
            </div>
            <div v-else style="word-break: break-all; white-space: normal;">
              {{ scope.row.value }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { getTopUpLogs } from '../../api/dijia.js';

export default {
  name: 'DxtPackageTopUpLog',
  data() {
    return {
      loading: false,
      theme: localStorage.getItem('theme'),
      theme3: localStorage.getItem('theme3'),
      theme8: localStorage.getItem('theme8'),
      tableData: [],
      pageTotal: 0,
      tableKey: 0,
      query: {
        phone: '',
        logType: null,
        source: null,
        operatorAccount: '',
        pageIndex: 1,
        pageSize: 20
      },
      detailVisible: false,
      currentLog: null,
      detailList: []
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      getTopUpLogs(this.query).then(res => {
        this.loading = false;
        if (res?.code === 200) {
          this.tableData = res.data.list || [];
          this.pageTotal = res.data.total || 0;
        } else {
          this.$message.error(res.message || '查询失败');
        }
      }).catch(err => {
        this.loading = false;
        this.$message.error('查询失败，请稍后再试');
        console.error(err);
      });
    },
    resetQuery() {
      this.query = {
        phone: '',
        logType: null,
        source: null,
        operatorAccount: '',
        pageIndex: 1,
        pageSize: 20
      };
      this.getData();
    },
    handlePageChange(val) {
      this.query.pageIndex = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.query.pageIndex = 1;
      this.getData();
    },
    showDetail(row) {
      this.currentLog = row;
      this.detailVisible = true;
      
      this.detailList = [
        { label: '日志类型', value: this.getLogTypeText(row.logType), isTag: true, tagType: this.getLogTypeTag(row.logType) },
        { label: '来源', value: this.getSourceText(row.source), isTag: true, tagType: this.getSourceTag(row.source) },
        { label: '号码', value: row.phone },
        { label: '套餐周期', value: row.yearMonth },
        { label: '操作人', value: row.operatorAccount },
        { label: '操作人ID', value: row.operatorId || '-' },
        { label: '号码状态', value: row.numberState || '-' },
        { label: '当前余额', value: (row.currentBalance !== null && row.currentBalance !== undefined) ? row.currentBalance.toFixed(2) + ' 元' : '-' },
        { label: '运营商套餐', value: row.packagesName || '-' },
        { label: 'SJTX套餐', value: row.sjtxPackagesName || '-' },
        { label: '套餐类型', value: row.packageType === 0 ? '整月' : '半月' },
        { label: '云企通价格', value: (row.sjtxPrice !== null && row.sjtxPrice !== undefined) ? row.sjtxPrice.toFixed(2) + ' 元' : '-' },
        { label: '迪信通价格', value: (row.dxtPrice !== null && row.dxtPrice !== undefined) ? row.dxtPrice.toFixed(2) + ' 元' : '-' },
        { label: '充值金额', value: (row.rechargeAmount !== null && row.rechargeAmount !== undefined) ? row.rechargeAmount.toFixed(2) + ' 元' : '-' },
        { label: '截留金额', value: (row.needIntercept !== null && row.needIntercept !== undefined) ? row.needIntercept.toFixed(2) + ' 元' : '-' },
        { label: '立即到账金额', value: (row.immediateArrivalAmount !== null && row.immediateArrivalAmount !== undefined) ? row.immediateArrivalAmount.toFixed(2) + ' 元' : '-' },
        { label: '次月应到账金额', value: (row.nextMonthArrivalAmount !== null && row.nextMonthArrivalAmount !== undefined) ? row.nextMonthArrivalAmount.toFixed(2) + ' 元' : '-' },
        { label: '次月实际到账金额', value: (row.nextMonthActualArrivalAmount !== null && row.nextMonthActualArrivalAmount !== undefined) ? row.nextMonthActualArrivalAmount.toFixed(2) + ' 元' : '-' },
        { label: '处理类型', value: row.processType || '-' },
        { label: '批次号', value: row.uid || '-' },
        { label: '文件批次号', value: row.fileBatchNo || '-' },
        { label: '支付订单号', value: row.orderId || '-' },
        { label: '迪信通订单号', value: row.dxtOrderId || '-' },
        { 
          label: '充值成功', 
          value: row.rechargeSuccess === true ? '是' : row.rechargeSuccess === false ? '否' : '-',
          isSuccess: true,
          color: row.rechargeSuccess === true ? '#67C23A' : row.rechargeSuccess === false ? '#F56C6C' : ''
        },
        { label: '充值结果', value: row.rechargeResult || '-' },
        { label: '失败原因', value: row.failReason || '-' },
        { label: '备注', value: row.remark || '-' },
        { label: '次月处理时间', value: this.formatTime(row.nextMonthProcessTime) },
        { label: '创建时间', value: this.formatTime(row.createdAt) }
      ];
    },
    getLogTypeText(type) {
      const map = {
        'ORDER_CREATE': '订单创建',
        'IMMEDIATE_ARRIVAL': '立即到账',
        'NEXT_MONTH_ARRIVAL': '次月到账'
      };
      return map[type] || type;
    },
    getLogTypeTag(type) {
      const map = {
        'ORDER_CREATE': 'primary',
        'IMMEDIATE_ARRIVAL': 'success',
        'NEXT_MONTH_ARRIVAL': 'warning'
      };
      return map[type] || 'info';
    },
    getSourceText(source) {
      const map = {
        'PUBLIC_ACCOUNT': '公众号',
        'BATCH_TOPUP': '后台批量',
        'FILE_RECHARGE': '文件充值'
      };
      return map[source] || source;
    },
    getSourceTag(source) {
      const map = {
        'PUBLIC_ACCOUNT': 'success',
        'BATCH_TOPUP': 'warning',
        'FILE_RECHARGE': 'danger'
      };
      return map[source] || 'info';
    },
    formatTime(time) {
      if (!time) return '-';
      // 处理 MongoDB 返回的时间格式
      if (typeof time === 'string') {
        return time.replace('T', ' ').substring(0, 19);
      }
      return time;
    }
  }
};
</script>

<style scoped>
.container {
  padding: 20px;
}

.handle-box {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.table {
  width: 100%;
  font-size: 14px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
